import * as _ from 'lodash'
import { required, helpers } from 'vuelidate/lib/validators'
import Api from '@/providers/Api'
import User from '@/apps/default/User'

/**
 * Model "class" for Appointment - defines useful field metadata for building and validating forms
 */

export default {
  fields: {
    participant_id: {
      label: 'FIELD_APPOINTMENT_PARTICIPANT',
      type: 'multiselect',
      multiselectOptions: {
        placeholder: 'Type name to search',
        label: 'fullname',
        multiple: false,
      },
      async doSearch (query) {
        const filters = { name: { field: 'text', value: query } }
        return Api.getPatients(this, filters, {}, User.practitionerPracticeId()).then((provider) => {
          return _.map(provider, (prov) => {
            return prov.participant
          })
        })
      }
    },
    practitioner_id: {
      label: 'FIELD_APPOINTMENT_PRACTITIONER',
      type: 'text',
    },
    date: {
      label: 'FIELD_APPOINTMENT_CAL_DATE',
      type: 'date',
    },
    startTime: {
      label: 'FIELD_APPOINTMENT_START',
      type: 'time',
      locale: 'en',
      minutesStep: '5'
    },
    endTime: {
      label: 'FIELD_APPOINTMENT_END',
      type: 'time',
      locale: 'en',
      minutesStep: '5'
    },
    emr_id: {
      label: 'FIELD_APPOINTMENT_EMR_ID',
      type: 'text',
    },
  }
}
